// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_GetBulkStatisticsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for get_bulk_statistics endpoint
 * Returns bulk operation statistics as dynamic key-value pairs
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadasLote_GetBulkStatisticsResponseDados {
total_operations?: number
total_messages_scheduled?: number
total_messages_error?: number
avg_messages_per_operation?: number
}

export type MensagensProgramadasLote_GetBulkStatisticsResponse = ApiResponse<MensagensProgramadasLote_GetBulkStatisticsResponseDados>;

registerResponseContract('MensagensProgramadasLote_GetBulkStatisticsResponse', {
  total_operations:           { type: 'number',  required: false },
  total_messages_scheduled:   { type: 'number',  required: false },
  total_messages_error:       { type: 'number',  required: false },
  avg_messages_per_operation: { type: 'number',  required: false },
})
